// Shopify cart mechanics shared by the Woodstock adapters and owned quick offers.
// Callers retain request timing, errors, focus, loading and drawer presentation.
window.OkazoCart = {
  sectionData(sections) {
    return {
      sections: [...new Set(sections.map((section) => section.id).filter(Boolean))],
      sections_url: window.location.pathname,
    };
  },

  addRequest(form, sections) {
    const config =
      typeof fetchConfig === "function"
        ? fetchConfig("javascript")
        : { method: "POST", headers: { Accept: "application/javascript" } };
    config.headers = { ...config.headers, "X-Requested-With": "XMLHttpRequest" };
    delete config.headers["Content-Type"];
    const formData = new FormData(form);
    if (!formData.has("quantity")) formData.append("quantity", "1");
    const sectionData = this.sectionData(sections);
    if (sectionData.sections.length) {
      formData.set("sections", sectionData.sections.join(","));
      formData.set("sections_url", sectionData.sections_url);
    }
    config.body = formData;
    return { config, formData };
  },

  changeRequest(line, quantity, sections) {
    return {
      ...fetchConfig(),
      body: JSON.stringify({ line, quantity, ...this.sectionData(sections) }),
    };
  },

  // `section` is an optional destination container ID. `id` always identifies
  // the Shopify response section; one response may supply several fragments.
  renderSections(payload, sections) {
    const parsed = new Map();
    for (const section of sections) {
      const html = payload.sections?.[section.id];
      if (!html) continue;
      if (!parsed.has(section.id)) parsed.set(section.id, new DOMParser().parseFromString(html, "text/html"));
      const source = parsed.get(section.id).querySelector(section.selector || ".shopify-section");
      const container = document.getElementById(section.section || section.id);
      const target = section.section
        ? container?.querySelector(section.selector) || container
        : section.selector
          ? document.querySelector(section.selector)
          : container;
      if (source && target) target.innerHTML = source.innerHTML;
    }
  },

  publishAdded(form, cartData, source, productVariantId) {
    form.dispatchEvent(new CustomEvent("okazo:cart-added", { bubbles: true }));
    document.dispatchEvent(
      new CustomEvent("afterCartChanged", {
        detail: { productVariantId, source, cartData },
      }),
    );
  },
};
